import React from "react";
import PropTypes from "prop-types";
import { getFormattedString, getAbsoluteValue } from "./Input.utlis";

import "./style.scss";

export function Input(props) {
  const className = `ps_timer_input ${props.className}`;

  const [value, setValue] = React.useState();

  React.useEffect(() => {
    setValue(getFormattedString(props.value));
  }, [props.value]);

  const onChange = (event) => {
    const updatedValue = event.target.value;
    const updatedNumber = getAbsoluteValue(updatedValue);
    if (!isNaN(updatedNumber)) {
      const formattedValue = getFormattedString(updatedNumber);
      setValue(formattedValue);
    } else if (updatedValue === "") setValue(undefined);
  };

  const onBlur = () => {
    const currentValue = getAbsoluteValue(value);
    if (currentValue === undefined) props.setValue(0);
    props.setValue(currentValue);
  };

  return (
    <input
      className={className}
      tabIndex={props.tabIndex}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      aria-label={props.ariaLabel}
    />
  );
}

Input.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   *  specifies if keyboard accessible or not
   */
  tabIndex: PropTypes.number,
  /**
   * value displayed on input
   */
  value: PropTypes.number,
  /**
   * callback to set value of input text (here used only when loosing focus on input)
   */
  setValue: PropTypes.func,
};

Input.defaultProps = {
  className: "",
  value: 0,
  tabIndex: 0,
};
